import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import { toast } from "react-toastify";
import axios from "../utils/axiosInstance";

// Define register arrays outside component to avoid re-creation
const WPRegisters = [
  // { key: "AI10", label: "Main Motor Speed Ref" },
  // { key: "AI11", label: "Main Motor Amps" },
  // { key: "AI12", label: "Cooler Motor Amps" },
  { key: "COMP_OIL_PRES", label: "Compressor Oil Pressure" },
  { key: "DISCHARGE_2_TEMP", label: "2nd Stage Discharge Temp" },
  { key: "DISCHARGE_PRES", label: "Discharge Pressure" },
  { key: "DISCHARGE_TEMP_FINAL", label: "Discharge Temperature" },
  { key: "ENGINE_COOLANT_TEMP", label: "Engine Coolant Temp" },
  { key: "ENGINE_HOURMETER", label: "Engine Hourmeter" },
  { key: "ENGINE_OIL_PRES", label: "Engine Oil Press" },
  // { key: "ENGINE_MANIFOLD_PRES", label: "Engine Manifold Pres" },
  { key: "ENGINE_OIL_TEMP", label: "Engine Oil Temp" },
  { key: "ENGINE_SPEED", label: "Engine Speed" },
  { key: "FIELD_PRES", label: "Field Pressure" },

  // { key: "FLOW_RATE_SP", label: "Flow Rate SP" },
  { key: "INTERSTAGE_PRES", label: "Interstage Pressure" },
  // { key: "STATE", label: "State" },
  { key: "SUCTION_PRES", label: "Suction Scrubber Pressure" },
  { key: "SYSTEM_VOTLS", label: "System Volts" },
  // { key: "TAILSHAFT_TEMP", label: "Tailshaft Temp" },
  { key: "SHUTDOWN_ENUM", label: "Shutdown Enum" },
  { key: "STATE", label: "State" },
  { key: "FLOW_METER", label: "Main Flow Meter" },
];

const C5Registers = [
  // { key: "AI7", label: "AI7" },
  // { key: "AI8", label: "AI8" },
  // { key: "AI9", label: "AI9" },
  // { key: "AI10", label: "Main Motor Speed Ref" },
  // { key: "AI11", label: "Main Motor Amps" },
  // { key: "AI12", label: "Cooler Motor Amps" },
  { key: "COMP_HOURMETER", label: "Comp Hourmeter" },
  { key: "DISCHARGE_2_TEMP", label: "2nd Stage Discharge Temp" },
  { key: "DISCHARGE_TEMP_FINAL", label: "Discharge Temperature" },
  { key: "ENGINE_COOLANT_TEMP", label: "Engine Coolant Temp" },
  { key: "ENGINE_HOURMETER", label: "Engine Hourmeter" },
  { key: "ENGINE_OIL_PRES", label: "Engine Oil Press" },
  { key: "ENGINE_MANIFOLD_PRES", label: "Engine Manifold Pres" },
  { key: "ENGINE_OIL_TEMP", label: "Engine Oil Temp" },
  { key: "FLOW_RATE_SP", label: "Flow Rate SP" },
  { key: "TAILSHAFT_TEMP", label: "Tailshaft Temp" },
  { key: "COMP_OIL_PRES", label: "Compressor Oil Pressure" },
  { key: "DISCHARGE_PRES", label: "Discharge Pressure" },
  { key: "ENGINE_SPEED", label: "Engine Speed" },
  { key: "FIELD_PRES", label: "Field Pressure" },
  { key: "INTERSTAGE_PRES", label: "Interstage Pressure" },
  { key: "SUCTION_PRES", label: "Suction Scrubber Pressure" },
  { key: "SYSTEM_VOTLS", label: "System Volts" },
  { key: "FLOW_METER", label: "Flow Meter" },
  // { key: "SPN1", label: "SPN1" },
  // { key: "SPN2", label: "SPN2" },
  // { key: "SPN3", label: "SPN3" },
  // { key: "SPN4", label: "SPN4" },
  // { key: "FMI1", label: "FMI1" },
  // { key: "FMI2", label: "FMI2" },
  // { key: "FMI3", label: "FMI3" },
  // { key: "FMI4", label: "FMI4" },
  // { key: "CM1", label: "CM1" },
  // { key: "CM2", label: "CM2" },
  // { key: "CM3", label: "CM3" },
  // { key: "CM4", label: "CM4" },
  // { key: "LAT", label: "LAT" },
  // { key: "LON", label: "LON" },
];
const C5ERegisters = [
  // { key: "AI7", label: "AI7" },
  // { key: "AI8", label: "AI8" },
  // { key: "AI9", label: "AI9" },
  { key: "AI10", label: "Main Motor Speed Ref" },
  { key: "AI11", label: "Main Motor Amps" },
  { key: "AI12", label: "Cooler Motor Amps" },
  { key: "COMP_HOURMETER", label: "Comp Hourmeter" },
  { key: "DISCHARGE_2_TEMP", label: "2nd Stage Discharge Temp" },
  { key: "DISCHARGE_TEMP_FINAL", label: "Discharge Temperature" },
  // { key: "ENGINE_COOLANT_TEMP", label: "Engine Coolant Temp" },
  { key: "ENGINE_HOURMETER", label: "Engine Hourmeter" },
  // { key: "ENGINE_OIL_PRES", label: "Engine Oil Press" },
  // { key: "ENGINE_MANIFOLD_PRES", label: "Engine Manifold Pres" },
  // { key: "ENGINE_OIL_TEMP", label: "Engine Oil Temp" },
  { key: "FLOW_RATE_SP", label: "Flow Rate SP" },
  { key: "TAILSHAFT_TEMP", label: "Tailshaft Temp" },
  { key: "COMP_OIL_PRES", label: "Compressor Oil Pressure" },
  { key: "DISCHARGE_PRES", label: "Discharge Pressure" },
  // { key: "ENGINE_SPEED", label: "Engine Speed" },
  { key: "FIELD_PRES", label: "Field Pressure" },
  { key: "INTERSTAGE_PRES", label: "Interstage Pressure" },
  { key: "SUCTION_PRES", label: "Suction Scrubber Pressure" },
  { key: "SYSTEM_VOTLS", label: "System Volts" },
  { key: "FLOW_METER", label: "Flow Meter" },
  // { key: "SPN1", label: "SPN1" },
  // { key: "SPN2", label: "SPN2" },
  // { key: "SPN3", label: "SPN3" },
  // { key: "SPN4", label: "SPN4" },
  // { key: "FMI1", label: "FMI1" },
  // { key: "FMI2", label: "FMI2" },
  // { key: "FMI3", label: "FMI3" },
  // { key: "FMI4", label: "FMI4" },
  // { key: "CM1", label: "CM1" },
  // { key: "CM2", label: "CM2" },
  // { key: "CM3", label: "CM3" },
  // { key: "CM4", label: "CM4" },
  // { key: "LAT", label: "LAT" },
  // { key: "LON", label: "LON" },
];

export default function TimeRangeSelector({
  deviceId,
  timeRange,
  setTimeRange,
  onRefresh,
  loading,
  selectedRegisters,
  setSelectedRegisters,
}) {
  const [mode, setMode] = useState("preset");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [ctrlType, setCtrlType] = useState("");
  const [showRegisterSelector, setShowRegisterSelector] = useState(false);

  const modalRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchEngineData = React.useCallback(async (deviceId) => {
    if (!deviceId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/engine-data/${deviceId}`
      );
      setCtrlType(response.data.type);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    if (deviceId) {
      fetchEngineData(deviceId);
    }
  }, [deviceId, fetchEngineData]);

  // Get current register set based on device type
  const Registers = React.useMemo(() => {
    if (ctrlType === "C5") return C5Registers;
    if (ctrlType === "C5E") return C5ERegisters;
    if (ctrlType === "WellPro II") return WPRegisters;
    return [];
  }, [ctrlType]);

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showRegisterSelector &&
        modalRef.current &&
        !modalRef.current.contains(event.target)
      ) {
        setShowRegisterSelector(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showRegisterSelector]);

  const handleDisplayCharts = () => {
    updateUserChartFields(selectedRegisters);
    setShowRegisterSelector(false);
  };

  const updateUserChartFields = async (registers) => {
    if (!user) return;
    try {
      let body = {};
      if (ctrlType === "C5" || ctrlType === "C5E") {
        body = { ChartFieldsC5: JSON.stringify(registers) };
      } else if (ctrlType === "WellPro II") {
        body = { ChartFieldsWELLPRO: JSON.stringify(registers) };
      }

      await axios.put(
        `${process.env.REACT_APP_API_GATEAWAY}/users/${user.id}`,
        body
      );
      toast.success("Chart fields updated!");
    } catch (error) {
      toast.error("Failed to update chart fields");
      console.error(error);
    }
  };

  const handleApplyCustom = () => {
    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates");
      return;
    }

    const start = Math.floor(new Date(startDate).getTime() / 1000);
    const end = Math.floor(new Date(endDate).getTime() / 1000);

    if (start >= end) {
      toast.error("Start date must be before end date");
      return;
    }

    setTimeRange({
      type: "custom",
      start,
      end,
    });
  };

  return (
    <div className="mb-3 text-sm relative z-30">
      {/* Mobile Layout (< 640px) */}
      <div className="flex flex-col gap-2 sm:hidden">
        {/* Dropdowns Row */}
        <div className="flex gap-2">
          <div className="flex flex-col flex-1">
            <label className="text-gray-300 text-xs mb-1">Range Type</label>
            <select
              value={mode}
              onChange={(e) => setMode(e.target.value)}
              className="px-2 py-1 rounded bg-slate-800 text-white border border-slate-600 w-full"
            >
              <option value="preset">Preset Range</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>

          {mode === "preset" && (
            <div className="flex flex-col flex-1">
              <label className="text-gray-300 text-xs mb-1">Time Range</label>
              <select
                value={timeRange?.hours || 4}
                onChange={(e) =>
                  setTimeRange({
                    type: "preset",
                    hours: Number(e.target.value),
                  })
                }
                className="px-2 py-1 rounded bg-slate-800 text-white border border-slate-600 w-full"
              >
                <option value={4}>Last 4 hours</option>
                <option value={8}>Last 8 hours</option>
                <option value={24}>Last 24 hours</option>
                <option value={168}>Last week</option>
                <option value={336}>Last 2 weeks</option>
              </select>
            </div>
          )}

          {mode === "custom" && (
            <div className="flex flex-col flex-1">
              <label className="text-gray-300 text-xs mb-1">Start Date</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="px-2 py-1 rounded bg-slate-800 text-white border border-slate-600 w-full"
              />
            </div>
          )}
        </div>

        {/* Second row for custom mode end date */}
        {mode === "custom" && (
          <div className="flex gap-2">
            <div className="flex flex-col flex-1">
              <label className="text-gray-300 text-xs mb-1">End Date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="px-2 py-1 rounded bg-slate-800 text-white border border-slate-600 w-full"
              />
            </div>
          </div>
        )}

        {/* Buttons Row */}
        <div className="flex gap-2">
          {mode === "custom" && (
            <button
              onClick={handleApplyCustom}
              className="flex-1 px-3 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white font-medium"
            >
              Apply
            </button>
          )}

          <button
            onClick={onRefresh}
            disabled={loading}
            className={`flex-1 px-3 py-2 rounded text-white font-medium ${
              loading
                ? "bg-slate-600 cursor-not-allowed"
                : "bg-green-600 hover:bg-green-700"
            }`}
          >
            {loading ? "Loading..." : "↻ Refresh"}
          </button>

          <button
            onClick={() => setShowRegisterSelector(true)}
            className="flex-1 px-3 py-2 rounded bg-green-600 hover:bg-green-700 text-white font-medium"
          >
            Select Data
          </button>
        </div>
      </div>

      {/* Desktop/Tablet Layout (>= 640px) */}
      <div className="hidden sm:flex sm:flex-wrap sm:gap-3">
        {/* Range Type */}
        <div className="flex flex-col w-auto">
          <label className="text-gray-300 text-xs mb-1">Range Type</label>
          <select
            value={mode}
            onChange={(e) => setMode(e.target.value)}
            className="px-2 py-1 rounded bg-slate-800 text-white border border-slate-600"
          >
            <option value="preset">Preset Range</option>
            <option value="custom">Custom Range</option>
          </select>
        </div>

        {/* Preset Mode */}
        {mode === "preset" && (
          <>
            <div className="flex flex-col w-auto">
              <label className="text-gray-300 text-xs mb-1">Time Range</label>
              <select
                value={timeRange?.hours || 4}
                onChange={(e) =>
                  setTimeRange({
                    type: "preset",
                    hours: Number(e.target.value),
                  })
                }
                className="px-2 py-1 rounded bg-slate-800 text-white border border-slate-600"
              >
                <option value={4}>Last 4 hours</option>
                <option value={8}>Last 8 hours</option>
                <option value={24}>Last 24 hours</option>
                <option value={168}>Last week</option>
                <option value={336}>Last 2 weeks</option>
              </select>
            </div>
            <div className="lg:mt-[-5px] md:mt-[-5px] gap-3 flex flex-wrap">
              <button
                onClick={onRefresh}
                disabled={loading}
                className={`px-3 py-2 rounded text-white font-medium mt-[22px] ${
                  loading
                    ? "bg-slate-600 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                {loading ? "Loading..." : "↻ Refresh"}
              </button>

              <button
                onClick={() => setShowRegisterSelector(true)}
                className="px-3 py-2 rounded bg-green-600 hover:bg-green-700 text-white font-medium mt-[22px]"
              >
                Select Data
              </button>
            </div>
          </>
        )}

        {/* Custom Mode */}
        {mode === "custom" && (
          <>
            <div className="flex flex-col w-auto">
              <label className="text-gray-300 text-xs mb-1">Start Date</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="px-2 py-1 rounded bg-slate-800 text-white border border-slate-600"
              />
            </div>
            <div className="flex flex-col w-auto">
              <label className="text-gray-300 text-xs mb-1">End Date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="px-2 py-1 rounded bg-slate-800 text-white border border-slate-600"
              />
            </div>

            <button
              onClick={handleApplyCustom}
              className="px-3 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white font-medium"
            >
              Apply
            </button>

            <button
              onClick={onRefresh}
              disabled={loading}
              className={`px-3 py-2 rounded text-white font-medium ${
                loading
                  ? "bg-slate-600 cursor-not-allowed"
                  : "bg-green-600 hover:bg-green-700"
              }`}
            >
              {loading ? "Loading..." : "↻ Refresh"}
            </button>

            <button
              onClick={() => setShowRegisterSelector(true)}
              className="px-3 py-2 rounded bg-green-600 hover:bg-green-700 text-white font-medium"
            >
              Select Data
            </button>
          </>
        )}
      </div>

      {/* Register Selector Modal */}
      {showRegisterSelector && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-60 p-4 sm:p-6">
          <div
            ref={modalRef}
            className="bg-slate-800 p-4 rounded-lg w-full h-full sm:h-auto sm:w-96 max-h-full sm:max-h-[80vh] overflow-y-auto"
          >
            <h3 className="text-white font-semibold mb-2 text-lg">
              Select Registers
            </h3>
            <div className="mb-3 text-sm text-gray-300">
              Selected: {selectedRegisters?.length || 0} / {Registers.length}
            </div>

            <div className="flex flex-col gap-1 max-h-[60vh] overflow-y-auto">
              {Registers.map((reg) => {
                const isChecked =
                  Array.isArray(selectedRegisters) &&
                  selectedRegisters.includes(reg.key);

                return (
                  <label
                    key={reg.key}
                    className="flex items-center gap-3 mb-2 text-white text-sm cursor-pointer hover:bg-slate-700 p-2 rounded"
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      className="scale-110"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedRegisters((prev) =>
                            Array.isArray(prev) ? [...prev, reg.key] : [reg.key]
                          );
                        } else {
                          setSelectedRegisters((prev) =>
                            Array.isArray(prev)
                              ? prev.filter((r) => r !== reg.key)
                              : []
                          );
                        }
                      }}
                    />
                    {reg.label}
                  </label>
                );
              })}
            </div>

            <div className="flex flex-col sm:flex-row justify-end gap-2 mt-4">
              <button
                onClick={() => setShowRegisterSelector(false)}
                className="w-full sm:w-auto px-3 py-2 rounded bg-gray-600 hover:bg-gray-700 text-white font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleDisplayCharts}
                className="w-full sm:w-auto px-3 py-2 rounded bg-green-600 hover:bg-green-700 text-white font-medium"
              >
                Display Charts
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
